import Currency from '@/enums/Currency'

export const DecimalCurrencies: Array<keyof typeof Currency> = ['USD', 'AUD', 'CAD', 'GBP', 'SGD', 'EUR']
